import {hasReducedMotion} from "../utils/a11y";

interface CardCoverImagesObserverConfig {
	selector?: string;
	itemSelector?: string;
	delay?: number;
}

export const CardsCoverImagesObserver = {
	elements: [] as unknown as NodeListOf<HTMLElement>,
	observer: null as IntersectionObserver | null,

	delay: 1000,

	init(config?: CardCoverImagesObserverConfig): void {
		const selector = config?.selector ?? '.wv-cards-cover-image';
		this.elements = document.querySelectorAll<HTMLElement>(selector);

		if (!this.elements.length) {
			return;
		}

		if (config?.delay) {
			this.delay = config.delay;
		}

		this.bindClass();
		this.bindEvents();
	},

	bindClass(): void {
		this.handleIntersect = this.handleIntersect.bind(this);
		this.animate = this.animate.bind(this);
	},

	bindEvents(): void {
		this.observer = new IntersectionObserver(this.handleIntersect, {
			threshold: 0.3
		});

		this.elements.forEach((el) => {
			this.observer?.observe(el);
		});
	},

	handleIntersect(entries: IntersectionObserverEntry[]): void {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) {
				return;
			}

			const el = entry.target as HTMLElement;

			this.observer?.unobserve(el);

			this.animate(el);
		});
	},

	animate(parent: HTMLElement): void {
		const items = parent.querySelectorAll<HTMLElement>('.wv-card');

		items.forEach((item, index) => {
			// handle reduced motion
			if ( hasReducedMotion() ) {
				item.classList.add('wv-card--fade-in');
				return;
			}

			setTimeout(() => {
				item.classList.add('wv-card--fade-in');
			}, index * this.delay);
		});
	},

};
